module.exports = __webpack_public_path__ + "img/cate5.7cae4212.png";